import { ResourcesConfig } from 'aws-amplify';

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-2_AeGSycwff',
      userPoolClientId: '3lpb9iqahgk2p1g0k4pm2qivfr',
    },
  },
};

export default awsConfig;
